export const userIsAdmin = () => {
  let roles = window.userRoles || '';
  return roles.split(',').map(r => r.toLowerCase()).includes('admin');
}

export const getUserProfile = () => {
  let data = {};
  $.ajax({
    async: false,
    url: '/api/user.json',
    type: 'GET',
    dataType: 'json',
    success: function (resp) {
      data = resp;
    },
    error: function (){
      data = {};
    }
  });

  return data;
}
